import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { convertPermissionsToFlatArray } from 'utilities/dataFormatting/permissions';

import commonApi from 'api/commonApi'

const states = {
  v1: {
    authenticated: false,
    user: null
  }
};


let initialState = states.v1

export const workingHoursMigration = {
  1: () => states.v1
}

export const workingHoursSlice = createSlice({
  name: 'workingHours',
  initialState,
  reducers: {
    login: (state, action) => {
      const { payload } = action
      state.authenticated = true;
      state.user = payload;
    },
    logout: (state) => {
      state.authenticated = false;
      state.user = null;
    },
  },

});

export const { login, logout } = workingHoursSlice.actions;

export const selectUser = (state) => state.workingHours.user;
export const selectAuthenticated = (state) => state.workingHours.authenticated;

export default workingHoursSlice.reducer;